
<template>
  <v-autocomplete
                  v-model="value"
                  v-model:search="searchText"
                  :items="lstObjects"
                  :loading="loading"
                  item-title="name"
                  hide-details
                  :label="label"
                  density="compact"
                  clearable
                  return-object>
    <template v-slot:no-data>
      <div class="px-4">Digite sua busca</div>
    </template></v-autocomplete>
</template>
<script>
import api from '@/services'

export default {
  components: {},
  props: {
    user: Object,
    label: String,
    modelValue: Object,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      requestingApi: false,
      lstObjects: [],
      searchText: null,
      previousSearch: '',
      loading: false,
      timeoutSearchDelay: null,
      enableSearch: false,
    };
  },
  created() {
    var vm = this;

    vm.submitSearch()
  },
  activated() { },
  methods: {
    waitAndSearch() {
      var vm = this;
      if (vm.timeoutSearchDelay) {
        clearTimeout(vm.timeoutSearchDelay);
      }
      if (vm.searchText != "" && vm.searchText != " ") {
        vm.timeoutSearchDelay = setTimeout(() => {
          vm.submitSearch();
        }, 1500);
        vm.loading = true;
      }
    },
    submitSearch() {
      var vm = this;
      if (!vm.requestingApi) {
        let _searchText = vm.searchText;

        if (vm.enableSearch) {
          let _prev = (vm.previousSearch || "").toUpperCase();
          let _act = (_searchText || "").toUpperCase();
          if (_act == "" || (_act == " " && _prev == _act)) {
            vm.loading = false;
            return;
          }
        }
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.cashier
            .list({ searchText: _searchText, itemsPerPage: 30 }, 1)
            .then((result) => {
              vm.lstObjects = result?.data;
              if (result?.total && result?.total > 30) {
                vm.enableSearch = true
              }
            })
            .catch((err) => {
              //
            })
            .finally(() => {
              vm.requestingApi = false;
              vm.loading = false;
            });
        });
      }
    },
  },
  computed: {
    lstObjectsComputed() {
      var vm = this
      let _lst = []
      vm.lstObjects.forEach(el => {
        _lst.push({
          id_name: `[${el.id}] ${el.name}`,
          ...el
        })
      });
      return _lst
    },
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue) {
          if (!newValue.hasOwnProperty("idd_nae")) {
            newValue['id_name'] = `[${newValue.id}] ${newValue.name}`;
          }
        }
      },
      immediate: true
    },
    "searchText"(newVal, oldVal) {
      if (
        newVal &&
        newVal != " " &&
        newVal.toUpperCase() != oldVal?.toUpperCase()
      ) {
        if (this.enableSearch) {
          this.waitAndSearch();
        }
      }
    },
  },
};
</script>
